module.exports = __webpack_public_path__ + "img/home.56f82058.png";